import React, {
    memo,
    useContext,
    useMemo,
    useState,
    useEffect
} from 'react'

import StoreDB from '../../../../database/wrappers/store'
import { orderBy } from 'firebase/firestore'
import { useFormik } from 'formik'

import PageWrapper from '../../../../layout/PageWrapper/PageWrapper'
import SubHeader, {
    SubHeaderLeft,
    SubHeaderRight,
    SubheaderSeparator
} from '../../../../layout/SubHeader/SubHeader'

import Button from '../../../../components/bootstrap/Button'
import Dropdown, {
    DropdownMenu,
    DropdownToggle
} from '../../../../components/bootstrap/Dropdown'
import FormGroup from '../../../../components/bootstrap/forms/FormGroup'
import Label from '../../../../components/bootstrap/forms/Label'
import Select from '../../../../components/bootstrap/forms/Select'

import useDarkMode from '../../../../hooks/useDarkMode'

import { DefaultContext } from '../../../../contexts/default'
import { ResultsContext } from '../../../../contexts/results'

import Page from '../../../../layout/Page/Page'
import { ACCESS_LEVEL } from '../../../../types/roles'
import TabConsumo from './TabConsumo'
import TabInsumo from './TabInsumo'
import TabCMVInsumo from './TabCMVInsumo'
import TabGrafico from './TabGrafico'

const years = [
    {
        value: '2025',
        text: '2025',
    },
    {
        value: '2026',
        text: '2026',
    },
]

const months = [
    {
        value: '01',
        text: 'Janeiro',
    },
    {
        value: '02',
        text: 'Fevereiro',
    },
    {
        value: '03',
        text: 'Março',
    },
    {
        value: '04',
        text: 'Abril',
    },
    {
        value: '05',
        text: 'Maio',
    },
    {
        value: '06',
        text: 'Junho',
    },
    {
        value: '07',
        text: 'Julho',
    },
    {
        value: '08',
        text: 'Agosto',
    },
    {
        value: '09',
        text: 'Setembro',
    },
    {
        value: '10',
        text: 'Outubro',
    },
    {
        value: '11',
        text: 'Novembro',
    },
    {
        value: '12',
        text: 'Dezembro',
    },
];


const Cmv = () => {
    const { themeStatus } = useDarkMode()
    const TABS = {
        GRAFICO: 'Visão Geral CMV',
        INSUMO: 'CMV Produto',
        CMVINSUMO: 'CMV Insumo',
        CONSUMO: 'Entrada Insumo',
    }
    const [activeTab, setActiveTab] = useState(TABS.GRAFICO)
    const [storesInFilter, setstoresInFilter] = useState([]);

    const [dataFilter, setdataFilter] = useState({
        estab: '',
        store: '',
        firstDate: '',
        secondDate: '',
    });


    const {
        accessLevel,
        establishments,
        estabSelected,
    } = useContext(DefaultContext)

    const [filterMenu, setFilterMenu] = useState(false)


    function getDaysInMonth(year, month) {
        return new Date(year, month, 0).getDate();
    }

    const formik = useFormik({
        initialValues: {
            estab: '',
            store: '',
            month: '',
            year: '',
        },
        onSubmit: (values) => {
            const daysInMonth = getDaysInMonth(parseInt(values.year), parseInt(values.month));
            setFilterMenu(false);
            setdataFilter({
                estab: values.estab,
                store: values.store,
                firstDate: `${values.year}-${values.month}-01 00:00:00`,
                secondDate: `${values.year}-${values.month}-${daysInMonth} 23:59:59`,
            });
        },
    });


    useEffect(() => {
        formik.setFieldValue('estab', estabSelected)
    }, [])
    useEffect(() => {
        if (formik.values.estab) {
            const loadStores = () => {
                new StoreDB(formik.values.estab)
                    .getAll(orderBy('name', 'asc'))
                    .then(datas => {
                        setstoresInFilter(datas)
                        formik.setFieldValue('#')
                    })
                    .catch(error => console.error(error))
                    .finally(() => {
                    });
            }
            loadStores();

        }
    }, [formik.values.estab])

    const optionsEstablishments = useMemo(() =>
        establishments.map(item => ({ value: item.id, text: item.name }))
        , [establishments])


    const optionsStores = useMemo(() => {
        const options = storesInFilter.map(item => ({ value: item.id, text: item.name }))
        return options;
    }, [storesInFilter])

    return (
        <>
            <PageWrapper>
                <SubHeader>
                    <SubHeaderLeft className='d-flex flex-row flex-wrap align-items-center justify-content-sm-start justify-content-center mb-2 mt-2'>
                        <span className='h4 mb-0 fw-bold'>Relatórios</span>
                        <SubheaderSeparator />
                        {Object.keys(TABS).map((key) => (
                            <Button
                                className='mx-2 my-1'
                                key={key}
                                color={activeTab === TABS[key] ? 'success' : themeStatus}
                                onClick={() => setActiveTab(TABS[key])}>
                                {TABS[key]}
                            </Button>
                        ))}
                    </SubHeaderLeft>
                    <SubHeaderRight>
                        <Dropdown isOpen={filterMenu} setIsOpen={setFilterMenu}>
                            <DropdownToggle hasIcon={false}>

                                <Button icon='Filter' color='primary' isLight data-tour='filter'>
                                    Filtros
                                </Button>
                            </DropdownToggle>

                            <DropdownMenu
                                isAlignmentEnd
                                size='lg'
                                isCloseAfterLeave={false}
                                data-tour='filter-menu'>
                                <div className='container py-2'>
                                    <form className='row g-3' onSubmit={formik.handleSubmit}>
                                        {(accessLevel === ACCESS_LEVEL.ADMIN || accessLevel === ACCESS_LEVEL.MANAGER) &&
                                            <div className='col-12'>
                                                <FormGroup>
                                                    <Label htmlFor='unity'>Estabelecimento</Label>
                                                    <Select
                                                        id='estab'
                                                        placeholder='Selecione o estabelecimento'
                                                        list={optionsEstablishments}
                                                        onChange={formik.handleChange}
                                                        value={formik.values.estab}
                                                    />
                                                </FormGroup>
                                            </div>}
                                        <div className='col-12'>
                                            <FormGroup>
                                                <Label htmlFor='store'>Loja</Label>
                                                <Select
                                                    id='store'
                                                    placeholder='Selecione a loja'
                                                    list={optionsStores}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.store}
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-12'>
                                            <FormGroup>
                                                <Label htmlFor='unity'>Mês</Label>
                                                <Select
                                                    id='month'
                                                    placeholder='Selecione o mês'
                                                    list={months}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.month}
                                                />
                                            </FormGroup>
                                        </div>

                                        <div className='col-12'>
                                            <FormGroup>
                                                <Label htmlFor='unity'>Ano</Label>
                                                <Select
                                                    id='year'
                                                    placeholder='Selecione o ano'
                                                    list={years}
                                                    onChange={formik.handleChange}
                                                    value={formik.values.year}
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-6'>
                                            <Button
                                                className='w-100 text-dark bg-white'
                                                style={themeStatus === 'dark' ? { color: 'white' } : {}}
                                                color='warning'
                                                isOutline
                                                onClick={formik.resetForm}>
                                                Resetar
                                            </Button>
                                        </div>
                                        <div className='col-6'>
                                            <Button style={{ color: 'black' }} color='warning' className='w-100' type='submit'>
                                                Filtrar
                                            </Button>
                                        </div>
                                    </form>
                                </div>
                            </DropdownMenu>
                        </Dropdown>
                    </SubHeaderRight>
                </SubHeader>

                <Page container="fluid">
                    <TabInsumo
                        hidden={activeTab !== TABS.INSUMO}
                        dataFilter={dataFilter}
                    />

                    <TabCMVInsumo
                        hidden={activeTab !== TABS.CMVINSUMO}
                        dataFilter={dataFilter}
                    />

                    <TabConsumo
                        hidden={activeTab !== TABS.CONSUMO}
                        dataFilter={dataFilter}
                    />

                    <TabGrafico
                        hidden={activeTab !== TABS.GRAFICO}
                        dataFilter={dataFilter}
                    />
                </Page>
            </PageWrapper>
        </>
    )
}

export default memo(Cmv)
